import { useCallback } from 'react';
import { useNavigate, useParams, matchPath, useLocation } from 'react-router';

const getBackPath = (params: any, pathname: string) => {
  const routeBacks = [
    ['/events/:propertyId/:eventId', `/events/${params.propertyId}`],
    ['/events/:propertyId/create', `/events/${params.propertyId}`],
  ];

  const result =
    routeBacks.find(([path]) => matchPath(path, pathname))?.[1] || '/';

  return result;
};

export const useBackNavigation = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    navigate(getBackPath(params, location.pathname));
  }, [navigate, params, location.pathname]);
};
